var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { createPopper } from '@popperjs/core';
var SupportSearch = /** @class */ (function (_super) {
    __extends(SupportSearch, _super);
    function SupportSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "tooltip";
        _this.id = Math.random().toString(36).substring(2, 10);
        _this.tooltip = null;
        _this.visible = false;
        _this.isTouchScreenDevice = false;
        return _this;
    }
    SupportSearch.prototype.onVisibleChange = function (visible) {
        var _this = this;
        if (visible) {
            // Popper relies on the fact that the element is visible when created to calculate position
            // Without this, it only updates on page scroll/resize
            this.$nextTick(function () { var _a; return (_a = _this.tooltip) === null || _a === void 0 ? void 0 : _a.forceUpdate(); });
        }
    };
    SupportSearch.prototype.mounted = function () {
        this.isTouchScreenDevice = !!('ontouchstart' in window || navigator.maxTouchPoints);
        this.$nextTick(function () {
            var _a;
            var triggerElement = this.centerToParentElement ?
                (_a = this.$refs.wrapper) === null || _a === void 0 ? void 0 : _a.parentElement :
                this.$refs.trigger;
            this.tooltip = createPopper(triggerElement, this.$refs.tooltip, {
                placement: 'bottom',
            });
        });
    };
    SupportSearch.prototype.showTooltip = function () {
        this.visible = true;
    };
    SupportSearch.prototype.hideTooltip = function () {
        this.visible = false;
    };
    SupportSearch.prototype.toggleTooltip = function (event) {
        var targetElement = event.target;
        if (targetElement.tagName !== 'button') {
            targetElement = targetElement.parentNode;
        }
        if (targetElement) {
            targetElement.focus();
        }
        this.visible = !this.visible;
    };
    SupportSearch.prototype.destroyed = function () {
        var _a;
        (_a = this.tooltip) === null || _a === void 0 ? void 0 : _a.destroy();
    };
    __decorate([
        Prop({ type: String, default: "" })
    ], SupportSearch.prototype, "text", void 0);
    __decorate([
        Prop({ type: String, default: "" })
    ], SupportSearch.prototype, "label", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], SupportSearch.prototype, "centerToParentElement", void 0);
    __decorate([
        Watch('visible')
    ], SupportSearch.prototype, "onVisibleChange", null);
    SupportSearch = __decorate([
        Component({})
    ], SupportSearch);
    return SupportSearch;
}(Vue));
export default SupportSearch;
